import { twMerge } from "tailwind-merge";
import { ElementType, HTMLAttributes, forwardRef } from "react";

export interface NavProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

const Nav = forwardRef<HTMLElement, NavProps>((props, ref) => {
  const { className, as: Component = "div", ...rest } = props;

  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge("flex  items-center", className)}
    />
  );
});

export default Nav;
